import axios from "../axiosInstance";
import { IBranchHierarchyRegionDto, IBranchRegionResponse } from "../@types/branchRegion";

export const getBranchRegions = async () => {
    try {
        let response = await axios.get('/api/branch-hierarchy/regions');
        const data: IBranchRegionResponse = response.data;
        return data
    } catch (error) {
        console.error(error)
    }
};

export const updateBranchRegion = async (branchRegion: IBranchHierarchyRegionDto | undefined) => {
    try {
        if (!branchRegion) return;
        const response = await axios.put('/api/branch-hierarchy/update-branch-region', branchRegion)
        const data: IBranchHierarchyRegionDto = response.data.branchDivision
        return data
    } catch (error) {
        console.error(error)
    }
};

export const createBranchRegion = async (branchRegion: IBranchHierarchyRegionDto | undefined) => {
    try {
        if (!branchRegion) return;
        let response = await axios.post('/api/branch-hierarchy/create-branch-region', branchRegion);
        const data: IBranchHierarchyRegionDto = response.data.branchDivision;
        return data
    } catch (error) {
        console.error(error)
    }
};